const ACCESS_TOKEN_KEY = 'access_token';

export interface AccessToken {
  token: string;
  loginDate: string;
  experitationPeriod: number;
}

const get = (): AccessToken => {
  try {
    return JSON.parse(`${window.localStorage.getItem(ACCESS_TOKEN_KEY)}`) || {};
  } catch (error) {
    return {} as AccessToken;
  }
};

const set = (accessToken: AccessToken) =>
  window.localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(accessToken));

const clear = () => window.localStorage.removeItem(ACCESS_TOKEN_KEY);

const storage = {
  get,
  set,
  clear,
};

export default storage;
